var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#F3F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7012 26.75C18.8328 26.978 19.0222 27.1674 19.2502 27.299C19.4782 27.4306 19.7369 27.4999 20.0002 27.4999C20.2635 27.4999 20.5221 27.4306 20.7501 27.299C20.9782 27.1674 21.1675 26.978 21.2992 26.75",
    stroke: "#6A7282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.446 22.4945C13.348 22.6019 13.2833 22.7354 13.2598 22.8789C13.2364 23.0223 13.2551 23.1695 13.3137 23.3025C13.3724 23.4356 13.4684 23.5487 13.5901 23.6281C13.7119 23.7075 13.8541 23.7499 13.9995 23.75H25.9995C26.1448 23.7501 26.287 23.7079 26.4089 23.6286C26.5307 23.5493 26.6268 23.4363 26.6856 23.3034C26.7444 23.1705 26.7633 23.0233 26.74 22.8798C26.7167 22.7364 26.6523 22.6028 26.5545 22.4952C25.557 21.467 24.4995 20.3743 24.4995 17C24.4995 15.8065 24.0253 14.6619 23.1814 13.818C22.3375 12.9741 21.1929 12.5 19.9995 12.5C18.806 12.5 17.6614 12.9741 16.8175 13.818C15.9736 14.6619 15.4995 15.8065 15.4995 17C15.4995 20.3743 14.4412 21.467 13.446 22.4945Z",
    stroke: "#6A7282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationImage);
export default __webpack_public_path__ + "static/media/NotificationImage.735c75a237a42bf8e21b14366d6fea23.svg";
export { ForwardRef as ReactComponent };